module.exports = __webpack_public_path__ + "static/media/pla_exa_ins.c677dd1b.png";